'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var warning = require('warning');
var reactDom = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);

var validationsFeatureFlagsDefault = {
    validationsRemoveExtraSpans: false,
    fixedValidationTextColors: false,
};
var ValidationsFeatureFlagsContext = React__default["default"].createContext(validationsFeatureFlagsDefault);
ValidationsFeatureFlagsContext.displayName = 'ValidationsFeatureFlagsContext';
ValidationsFeatureFlagsContext.__KONTUR_REACT_UI__ = 'ValidationsFeatureFlagsContext';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var getFullValidationsFlagsContext = function (flags) {
    return __assign(__assign({}, validationsFeatureFlagsDefault), flags);
};

var DEFAULT_TEXT_COLOR = '#d43517';
function getValidationTextColor(flags, theme, level) {
    if (level === void 0) { level = 'error'; }
    if (flags.fixedValidationTextColors) {
        if (!theme.validationsTextColorWarning && !theme.validationsTextColorError) {
            switch (level) {
                case 'warning':
                    return flags.darkTheme ? '#fdd481' : '#ef8b17';
                case 'error':
                    return flags.darkTheme ? '#ff887b' : '#cb3d35';
            }
        }
        return ((level === 'warning' ? theme.validationsTextColorWarning : theme.validationsTextColorError) || DEFAULT_TEXT_COLOR);
    }
    return DEFAULT_TEXT_COLOR;
}

/**
 * Проверяет, не является ли переданный аргумент null или undefined и исключает типы null и undefined из типа аргумента
 *
 * @param value Значение, которое нужно проверить и исключить из него типы
 * @returns Возвращает true, если переданный аргумент не является null или undefined иначе false
 */
var isNonNullable = function (value) {
    return value !== null && value !== undefined;
};

var defaultOrNamed = function (module, component) {
    return module && module.__esModule && module.default ? module.default : module[component];
};
var importContext = function (module, component) { return module[component] || React__default["default"].createContext({}); };
var Tooltip = defaultOrNamed(require('@skbkontur/react-ui/components/Tooltip'), 'Tooltip');
var ThemeContext = importContext(require('@skbkontur/react-ui/lib/theming/ThemeContext'), 'ThemeContext');
var ReactUiDetection = /** @class */ (function () {
    function ReactUiDetection() {
    }
    ReactUiDetection.isDatePicker = function (childrenArray) {
        var _a;
        return isNonNullable(childrenArray) && ((_a = childrenArray.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === 'DatePicker';
    };
    ReactUiDetection.isRadioGroup = function (childrenArray) {
        var _a;
        return isNonNullable(childrenArray) && ((_a = childrenArray.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === 'RadioGroup';
    };
    ReactUiDetection.isTokenInput = function (childrenArray) {
        var _a;
        return isNonNullable(childrenArray) && ((_a = childrenArray.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === 'TokenInput';
    };
    ReactUiDetection.isSwitcher = function (childrenArray) {
        var _a;
        return isNonNullable(childrenArray) && ((_a = childrenArray.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === 'Switcher';
    };
    ReactUiDetection.isComboBox = function (childrenArray) {
        var _a;
        return isNonNullable(childrenArray) && ((_a = childrenArray.type) === null || _a === void 0 ? void 0 : _a.__KONTUR_REACT_UI__) === 'ComboBox';
    };
    return ReactUiDetection;
}());

var ValidationText = function (_a) {
    var pos = _a.pos, children = _a.children, validation = _a.validation, dataTid = _a["data-tid"];
    var theme = React.useContext(ThemeContext);
    var featureFlags = getFullValidationsFlagsContext(React.useContext(ValidationsFeatureFlagsContext));
    var color = getValidationTextColor(featureFlags, theme, validation === null || validation === void 0 ? void 0 : validation.level);
    if (pos === 'right') {
        var childrenAndValidationText = (React__default["default"].createElement(React__default["default"].Fragment, null,
            children,
            React__default["default"].createElement("span", { "data-tid": dataTid, "data-validation-message": "text", style: { marginLeft: '10px', color: color } }, (validation && validation.message) || '')));
        return featureFlags.validationsRemoveExtraSpans ? (childrenAndValidationText) : (React__default["default"].createElement("span", { style: { display: 'inline-block' } }, childrenAndValidationText));
    }
    var validationText = (React__default["default"].createElement("span", { "data-tid": dataTid, "data-validation-message": "text", style: {
            color: color,
            overflow: 'visible',
            whiteSpace: 'nowrap',
            position: 'absolute',
            top: '2px',
            left: 0,
        } }, (validation && validation.message) || ''));
    return featureFlags.validationsRemoveExtraSpans ? (React__default["default"].createElement(React__default["default"].Fragment, null,
        children,
        React__default["default"].createElement("span", { style: { position: 'absolute', display: 'block' } }, validationText))) : (React__default["default"].createElement("span", { style: { position: 'relative', display: 'inline-block' } },
        children,
        React__default["default"].createElement("span", { style: { position: 'absolute', bottom: 0, left: 0, height: 0 } }, validationText)));
};
ValidationText.__KONTUR_REACT_UI__ = 'ValidationText';
ValidationText.displayName = 'ValidationText';

var ValidationTooltip = /** @class */ (function (_super) {
    __extends(ValidationTooltip, _super);
    function ValidationTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationTooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, pos = _a.pos, error = _a.error, render = _a.render, rest = __rest(_a, ["children", "pos", "error", "render"]);
        var onlyChild = React__default["default"].Children.only(children);
        var child = onlyChild && onlyChild.props ? onlyChild.props.children : null;
        return (React__default["default"].createElement(ValidationsFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = getFullValidationsFlagsContext(flags);
            return !_this.featureFlags.validationsRemoveExtraSpans &&
                (ReactUiDetection.isRadioGroup(child) ||
                    ReactUiDetection.isTokenInput(child) ||
                    ReactUiDetection.isSwitcher(child)) ? (React__default["default"].createElement(Tooltip, __assign({ useWrapper: false, pos: pos, render: error && render, trigger: 'hover&focus' }, rest), child)) : (React__default["default"].createElement(Tooltip, __assign({ pos: pos, render: error && render, trigger: 'hover&focus' }, rest), children));
        }));
    };
    ValidationTooltip.__KONTUR_REACT_UI__ = 'ValidationTooltip';
    ValidationTooltip.displayName = 'ValidationTooltip';
    return ValidationTooltip;
}(React__default["default"].Component));

/* eslint-disable react/display-name */
function tooltip(pos) {
    return function (control, hasError, validation) {
        return (React__default["default"].createElement(ValidationTooltip, { pos: pos, error: hasError, render: function () {
                if (!validation || !validation.message) {
                    return null;
                }
                return (validation && validation.message) || '';
            } }, control));
    };
}
function text(pos) {
    if (pos === void 0) { pos = 'right'; }
    return function (control, _hasError, validation) {
        return (React__default["default"].createElement(ValidationText, { pos: pos, validation: validation }, control));
    };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function createPropsGetter(defaultProps) {
    return function () {
        return this.props;
    };
}

var env = (typeof process === 'object' && process && process.env) || {};
var enableReactTesting = env.enableReactTesting, NODE_ENV = env.NODE_ENV, REACT_UI_TEST = env.REACT_UI_TEST, REACT_APP_REACT_UI_TEST = env.REACT_APP_REACT_UI_TEST, STORYBOOK_REACT_UI_TEST = env.STORYBOOK_REACT_UI_TEST;
var isReactUITestEnv = Boolean(REACT_UI_TEST) || // for cases when NODE_ENV is not usable (dev/prod)
    Boolean(REACT_APP_REACT_UI_TEST) || // for usage with CRA
    Boolean(STORYBOOK_REACT_UI_TEST) || // for usage with storybook
    Boolean(enableReactTesting); // deprecated, legacy variable
var isTestEnv = NODE_ENV === 'test' || isReactUITestEnv;
var isBrowser = typeof window !== 'undefined';
var canUseDOM = isBrowser && window.document && window.document.createElement;
function isElement(el) {
    if (isBrowser) {
        return el instanceof Element;
    }
    return false;
}
function isNode(node) {
    if (isBrowser) {
        return node instanceof Node;
    }
    return false;
}

/**
 * Checks if the value `null` or `undefined`.
 *
 * @param value Value to check for `null` and `undefined`.
 * @returns Returns `true` if `value` is `null` or `undefined`, else `false`.
 */
// @ts-expect-error: TypeScript doesn't consider the check inside of the function.
var isNullable = function (value) {
    return value === null || value === undefined;
};

exports.FocusMode = void 0;
(function (FocusMode) {
    FocusMode[FocusMode["Errors"] = 0] = "Errors";
    FocusMode[FocusMode["ErrorsAndWarnings"] = 1] = "ErrorsAndWarnings";
    FocusMode[FocusMode["None"] = 2] = "None";
})(exports.FocusMode || (exports.FocusMode = {}));

var ValidationContext = React__default["default"].createContext({
    register: function () { return undefined; },
    unregister: function () { return undefined; },
    instanceProcessBlur: function () { return undefined; },
    onValidationUpdated: function () { return undefined; },
    getSettings: function () { return ({
        scrollOffset: {},
        disableSmoothScroll: false,
    }); },
    isAnyWrapperInChangingMode: function () { return false; },
});
ValidationContext.displayName = 'ValidationContext';
var ValidationContextWrapper = /** @class */ (function (_super) {
    __extends(ValidationContextWrapper, _super);
    function ValidationContextWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childWrappers = [];
        _this.children = function (flags) {
            if (flags.validationsRemoveExtraSpans) {
                return _this.props.children;
            }
            return React__default["default"].createElement("span", null, _this.props.children);
        };
        _this.renderChildren = function (children) {
            if (React__default["default"].isValidElement(children)) {
                return React__default["default"].cloneElement(children, {
                    'data-tid': _this.props['data-tid'],
                });
            }
            return children;
        };
        return _this;
    }
    ValidationContextWrapper.prototype.getSettings = function () {
        var scrollOffset = {};
        if (typeof this.props.scrollOffset === 'number') {
            scrollOffset = { top: this.props.scrollOffset };
        }
        else {
            scrollOffset = isNullable(this.props.scrollOffset) ? {} : this.props.scrollOffset;
        }
        var _a = scrollOffset.top, top = _a === void 0 ? 50 : _a, _b = scrollOffset.bottom, bottom = _b === void 0 ? 0 : _b;
        return {
            scrollOffset: {
                top: top,
                bottom: bottom,
            },
            disableSmoothScroll: this.props.disableSmoothScroll,
        };
    };
    ValidationContextWrapper.prototype.register = function (wrapper) {
        this.childWrappers.push(wrapper);
    };
    ValidationContextWrapper.prototype.unregister = function (wrapper) {
        this.childWrappers.splice(this.childWrappers.indexOf(wrapper), 1);
        this.onValidationRemoved();
    };
    ValidationContextWrapper.prototype.instanceProcessBlur = function (instance) {
        for (var _i = 0, _a = this.childWrappers.filter(function (x) { return x !== instance && !x.isIndependent(); }); _i < _a.length; _i++) {
            var wrapper = _a[_i];
            wrapper.processBlur();
        }
    };
    ValidationContextWrapper.prototype.onValidationUpdated = function (wrapper, isValid) {
        var onValidationUpdated = this.props.onValidationUpdated;
        if (onValidationUpdated) {
            var isValidResult = !this.childWrappers.find(function (x) {
                if (x === wrapper) {
                    return !isValid;
                }
                return x.hasError();
            });
            onValidationUpdated(isValidResult);
        }
    };
    ValidationContextWrapper.prototype.isAnyWrapperInChangingMode = function () {
        return this.childWrappers.some(function (x) { return x.isChanging; });
    };
    ValidationContextWrapper.prototype.onValidationRemoved = function () {
        var onValidationUpdated = this.props.onValidationUpdated;
        if (onValidationUpdated) {
            var isValidResult = !this.childWrappers.find(function (x) { return x.hasError(); });
            onValidationUpdated(isValidResult);
        }
    };
    ValidationContextWrapper.prototype.getChildWrappersSortedByPosition = function () {
        var wrappersWithPosition = __spreadArray([], this.childWrappers, true).map(function (x) { return ({
            target: x,
            position: x.getControlPosition(),
        }); });
        wrappersWithPosition.sort(function (x, y) {
            var xPosition = x.position;
            var yPosition = y.position;
            if (isNullable(xPosition) && isNullable(yPosition)) {
                return 0;
            }
            if (isNullable(xPosition)) {
                return 1;
            }
            if (isNullable(yPosition)) {
                return -1;
            }
            if (Math.sign(xPosition.x - yPosition.x) !== 0) {
                return Math.sign(xPosition.x - yPosition.x);
            }
            return Math.sign(xPosition.y - yPosition.y);
        });
        return wrappersWithPosition.map(function (x) { return x.target; });
    };
    ValidationContextWrapper.prototype.validate = function (withoutFocusOrValidationSettings) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var focusMode, childrenWrappersSortedByPosition, firstError;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        focusMode = ValidationContextWrapper.getFocusMode(withoutFocusOrValidationSettings);
                        return [4 /*yield*/, Promise.all(this.childWrappers.map(function (x) { return x.processSubmit(); }))];
                    case 1:
                        _b.sent();
                        childrenWrappersSortedByPosition = this.getChildWrappersSortedByPosition();
                        firstError = childrenWrappersSortedByPosition.find(function (x) { return x.hasError(); });
                        if (focusMode === exports.FocusMode.ErrorsAndWarnings) {
                            (_a = childrenWrappersSortedByPosition.find(function (x) { return x.hasError() || x.hasWarning(); })) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                        if (focusMode === exports.FocusMode.Errors) {
                            firstError === null || firstError === void 0 ? void 0 : firstError.focus();
                        }
                        if (this.props.onValidationUpdated) {
                            this.props.onValidationUpdated(!firstError);
                        }
                        return [2 /*return*/, !firstError];
                }
            });
        });
    };
    ValidationContextWrapper.getFocusMode = function (withoutFocusOrValidationSettings) {
        if (typeof withoutFocusOrValidationSettings === 'object' && 'focusMode' in withoutFocusOrValidationSettings) {
            return withoutFocusOrValidationSettings.focusMode;
        }
        else if (!withoutFocusOrValidationSettings) {
            return exports.FocusMode.Errors;
        }
        return exports.FocusMode.None;
    };
    ValidationContextWrapper.prototype.render = function () {
        var _this = this;
        return (React__default["default"].createElement(ValidationsFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = getFullValidationsFlagsContext(flags);
            return (React__default["default"].createElement(ValidationContext.Provider, { value: _this }, _this.renderChildren(_this.children(_this.featureFlags))));
        }));
    };
    return ValidationContextWrapper;
}(React__default["default"].Component));

var ValidationContainer = /** @class */ (function (_super) {
    __extends(ValidationContainer, _super);
    function ValidationContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = createPropsGetter();
        _this.childContext = null;
        _this.refChildContext = function (el) { return (_this.childContext = el); };
        return _this;
    }
    ValidationContainer.prototype.submit = function (withoutFocusOrValidationSettings) {
        if (withoutFocusOrValidationSettings === void 0) { withoutFocusOrValidationSettings = { focusMode: exports.FocusMode.Errors }; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.childContext) {
                            throw new Error('childContext is not defined');
                        }
                        return [4 /*yield*/, this.childContext.validate(withoutFocusOrValidationSettings)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ValidationContainer.prototype.validate = function (withoutFocusOrValidationSettings) {
        if (withoutFocusOrValidationSettings === void 0) { withoutFocusOrValidationSettings = { focusMode: exports.FocusMode.Errors }; }
        if (!this.childContext) {
            throw new Error('childContext is not defined');
        }
        return this.childContext.validate(withoutFocusOrValidationSettings);
    };
    ValidationContainer.prototype.render = function () {
        return (React__default["default"].createElement(ValidationContextWrapper, { "data-tid": this.props['data-tid'], ref: this.refChildContext, scrollOffset: this.props.scrollOffset, disableSmoothScroll: this.getProps().disableSmoothScroll, onValidationUpdated: this.props.onValidationUpdated }, this.props.children));
    };
    ValidationContainer.__KONTUR_REACT_UI__ = 'ValidationContainer';
    ValidationContainer.displayName = 'ValidationContainer';
    ValidationContainer.defaultProps = {
        disableSmoothScroll: isTestEnv,
    };
    ValidationContainer.propTypes = {
        scrollOffset: function (props, propName, componentName) {
            var scrollOffset = props.scrollOffset;
            if (typeof scrollOffset === 'number') {
                return new Error("[".concat(componentName, "]: scrollOffset as a number type has been deprecated, now use object { top?: number; bottom?: number; }"));
            }
        },
    };
    return ValidationContainer;
}(React__default["default"].Component));

/* eslint-disable react/no-find-dom-node */
var isInstanceWithRootNode = function (instance) {
    return Boolean(instance) && Object.prototype.hasOwnProperty.call(instance, 'getRootNode');
};
/**
 * Temporary duplicates @skbkontur/react-ui/lib/rootNode/getRootNode.ts
 * */
var getRootNode = function (instance) {
    /**
     * Options of what instance can be:
     *  1. null or undefined
     *  2. DOM Element
     *  3. class Component instance (object)
     *  4. literally anything, returned from useImperativeHandle
     */
    if (!canUseDOM || !instance) {
        // instance can be `null` if component was unmounted
        // also checking undefined for convenient usage
        return null;
    }
    if (isElement(instance)) {
        // instance can be an Element already if its coming
        // from Refs of intrinsic elements (<div />, <button />, etc.)
        return instance;
    }
    var rootNode;
    if (isInstanceWithRootNode(instance)) {
        // it happened to be that native Node interface also has
        // the "getRootNode" method, but we can ignore it here
        // because we'd already checked the instance on being an Element
        // which is a subclass of Node, so, just fixing types here
        if (!isNode(instance)) {
            rootNode = instance.getRootNode();
        }
    }
    if (rootNode !== undefined) {
        // the getter exists and has returned something, it should be what we are looking for
        // probably its an Element or null (which is also OK, e.g. Popup/Tooltip/Hint before opening)
        return rootNode;
    }
    try {
        // rootNode is undefined, which means that the getter doesn't exists or returns the undefined
        // anyway, it tell us that the convention is not respected,
        // so, we have to fall back to the deprecated findDOMNode, which breaks StrictMode
        // instance can still be a class component or an imperative handle (i.e., anything, except null/undefined/Element)
        rootNode = reactDom.findDOMNode(instance);
    }
    catch (e) {
        // but findDOMNode doesn`t accept everything that instance can be at this point,
        // so we have to handle exceptions
        // see https://github.com/facebook/react/blob/cae63505/packages/react-dom/src/__tests__/findDOMNode-test.js#L66-L86
        warning__default["default"](false, '[getRootNode]: can`t fallback to findDOMNode.' +
            '\n' +
            'See https://github.com/skbkontur/retail-ui/blob/master/packages/react-ui/README.md#strictmode' +
            '\n\n' +
            e.message);
        return null;
    }
    // the findDOMNode can also return Text, but we are only interested in Elements, so just filter it
    return isElement(rootNode) ? rootNode : null;
};

function smoothScrollIntoView(element, scrollOffset) {
    return __awaiter(this, void 0, void 0, function () {
        var scrollableParent, parentRects, clientRects, topOffset, bottomOffset, html, viewportHeight, viewportWidth, isElementInViewport;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scrollableParent = findScrollableParent(element);
                    parentRects = scrollableParent.getBoundingClientRect();
                    clientRects = element.getBoundingClientRect();
                    topOffset = scrollOffset.top || 0;
                    bottomOffset = scrollOffset.bottom || 0;
                    if (!(scrollableParent === document.body)) return [3 /*break*/, 2];
                    html = document.documentElement || { clientHeight: 0, clientWidth: 0 };
                    viewportHeight = window.innerHeight || html.clientHeight;
                    viewportWidth = window.innerWidth || html.clientWidth;
                    isElementInViewport = clientRects.top >= topOffset &&
                        clientRects.left >= 0 &&
                        clientRects.bottom <= viewportHeight - bottomOffset &&
                        clientRects.right <= viewportWidth;
                    if (isElementInViewport) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, scrollBy({
                            left: clientRects.left,
                            top: clientRects.top - topOffset,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    if (clientRects.top - topOffset + 50 > parentRects.top && clientRects.bottom < parentRects.bottom) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, smoothScroll(scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top - topOffset)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, scrollBy({
                            left: parentRects.left,
                            top: parentRects.top,
                        })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function smoothScroll(element, x, y) {
    var context;
    if (element === getDocumentBodyStrict()) {
        context = {
            scrollable: window,
            startX: window.scrollX || window.pageXOffset,
            startY: window.scrollY || window.pageYOffset,
            method: scrollWindow,
            startTime: now(),
            x: x,
            y: y,
        };
    }
    else {
        context = {
            scrollable: element,
            startX: element.scrollLeft,
            startY: element.scrollTop,
            method: scrollElement,
            startTime: now(),
            x: x,
            y: y,
        };
    }
    return new Promise(function (resolve) { return step(__assign(__assign({}, context), { resolve: resolve })); });
}
function step(context) {
    var time = now();
    var elapsed = Math.min(1, (time - context.startTime) / ScrollTime);
    var value = ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(context.scrollable, currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) {
        window.requestAnimationFrame(function () { return step(context); });
    }
    else {
        context.resolve();
    }
}
var ScrollTime = 468;
var getScrollWindow = function (isBrowser) {
    if (isBrowser) {
        if (typeof window.scroll === 'function') {
            return function (_, x, y) { return window.scroll(x, y); };
        }
        return function (_, x, y) { return window.scrollTo(x, y); };
    }
    return function () { return undefined; };
};
var scrollWindow = getScrollWindow(isBrowser);
var now = isBrowser && window.performance && window.performance.now
    ? window.performance.now.bind(window.performance)
    : Date.now;
function scrollElement(element, x, y) {
    element.scrollLeft = x;
    element.scrollTop = y;
}
function ease(time) {
    return 0.5 * (1 - Math.cos(Math.PI * time));
}
function getDocumentBodyStrict() {
    if (isNullable(document.body)) {
        throw new Error('Scrolling can be used only in browser');
    }
    return document.body;
}
function findScrollableParent(el) {
    var isBody;
    var hasScrollableSpace;
    var hasVisibleOverflow;
    var currentElement = el;
    do {
        if (isNullable(currentElement.parentElement) || !(currentElement.parentElement instanceof HTMLElement)) {
            return getDocumentBodyStrict();
        }
        currentElement = currentElement.parentElement;
        isBody = currentElement === document.body;
        hasScrollableSpace =
            currentElement.clientHeight < currentElement.scrollHeight ||
                currentElement.clientWidth < currentElement.scrollWidth;
        hasVisibleOverflow = window.getComputedStyle(currentElement, null).overflow === 'visible';
    } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));
    isBody = null;
    hasScrollableSpace = null;
    hasVisibleOverflow = null;
    return currentElement;
}
function scrollBy(_a) {
    var left = _a.left, top = _a.top;
    return smoothScroll(getDocumentBodyStrict(), Math.floor(left) + (window.scrollX || window.pageXOffset), Math.floor(top) + (window.scrollY || window.pageYOffset));
}

function getVisibleValidation(visible, actual, changing) {
    var from = function (type) { return getType(visible) === type; };
    var to = function (type) { return getType(actual) === type; };
    if (to('immediate')) {
        return actual;
    }
    if (changing) {
        return from('immediate') ? null : visible;
    }
    if (from(null) && to('lostfocus')) {
        return null;
    }
    if (to('lostfocus')) {
        return actual;
    }
    if (from('submit') && to('submit')) {
        return visible;
    }
    return null;
}
function getType(validation) {
    return validation ? validation.behaviour : null;
}
function getLevel(validation) {
    return validation ? validation.level : null;
}
function getIndependent(validation) {
    return validation ? validation.independent : null;
}
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    return !!a && !!b && a.behaviour === b.behaviour && a.message === b.message && a.independent === b.independent;
}

if (isBrowser && typeof HTMLElement === 'undefined') {
    var w = window;
    w.HTMLElement = w.Element;
}
var ValidationWrapperInternal = /** @class */ (function (_super) {
    __extends(ValidationWrapperInternal, _super);
    function ValidationWrapperInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            validation: null,
        };
        _this.isChanging = false;
        _this.context = _this.context;
        _this.customRef = function (instance) {
            var children = _this.props.children;
            _this.setRootNode(instance);
            var child = children; // todo type or maybe React.Children.only
            if (child && child.ref) {
                if (typeof child.ref === 'function') {
                    child.ref(instance);
                }
                if (Object.prototype.hasOwnProperty.call(child.ref, 'current')) {
                    child.ref.current = instance;
                }
            }
            _this.child = instance;
        };
        _this.setRootNode = function (element) {
            _this.rootNode = getRootNode(element);
        };
        _this.getRootNode = function () {
            return _this.rootNode;
        };
        return _this;
    }
    ValidationWrapperInternal.prototype.componentDidMount = function () {
        warning__default["default"](this.context, 'ValidationWrapper should appears as child of ValidationContainer.\n' +
            'https://tech.skbkontur.ru/react-ui-validations/#/getting-started');
        if (this.context) {
            this.context.register(this);
        }
        this.applyValidation(this.props.validation);
    };
    ValidationWrapperInternal.prototype.componentWillUnmount = function () {
        this.context.unregister(this);
    };
    ValidationWrapperInternal.prototype.componentDidUpdate = function () {
        this.applyValidation(this.props.validation);
    };
    ValidationWrapperInternal.prototype.focus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var htmlElement, _a, disableSmoothScroll, scrollOffset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        htmlElement = this.getRootNode();
                        if (!(htmlElement instanceof HTMLElement)) return [3 /*break*/, 3];
                        _a = this.context.getSettings(), disableSmoothScroll = _a.disableSmoothScroll, scrollOffset = _a.scrollOffset;
                        if (!!disableSmoothScroll) return [3 /*break*/, 2];
                        return [4 /*yield*/, smoothScrollIntoView(htmlElement, scrollOffset)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.child && typeof this.child.focus === 'function') {
                            this.child.focus();
                        }
                        _b.label = 3;
                    case 3:
                        this.isChanging = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ValidationWrapperInternal.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, dataTid = _a["data-tid"];
        var validation = this.state.validation;
        var clonedChild = children ? (React__default["default"].cloneElement(children, {
            ref: this.customRef,
            error: !this.isChanging && getLevel(validation) === 'error',
            warning: !this.isChanging && getLevel(validation) === 'warning',
            onBlur: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.handleBlur();
                if (children.props && children.props.onBlur) {
                    (_a = children.props).onBlur.apply(_a, args);
                }
            },
            onChange: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isChanging = true;
                if (children.props && children.props.onChange) {
                    (_a = children.props).onChange.apply(_a, args);
                }
            },
            onValueChange: function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isChanging = true;
                if (children.props && children.props.onValueChange) {
                    (_a = children.props).onValueChange.apply(_a, args);
                }
            },
        })) : (React__default["default"].createElement("span", { ref: this.setRootNode }));
        if (ReactUiDetection.isComboBox(clonedChild)) {
            clonedChild = React__default["default"].cloneElement(clonedChild, {
                onInputValueChange: function () {
                    var _a;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this.isChanging = true;
                    _this.forceUpdate();
                    if (children && children.props && children.props.onInputValueChange) {
                        return (_a = children.props).onInputValueChange.apply(_a, args);
                    }
                },
            });
        }
        return (React__default["default"].createElement(ValidationsFeatureFlagsContext.Consumer, null, function (flags) {
            _this.featureFlags = getFullValidationsFlagsContext(flags);
            return React__default["default"].cloneElement(_this.props.errorMessage(_this.featureFlags.validationsRemoveExtraSpans ? clonedChild : React__default["default"].createElement("span", null, clonedChild), !!validation, validation), {
                'data-tid': dataTid,
            });
        }));
    };
    ValidationWrapperInternal.prototype.getControlPosition = function () {
        var htmlElement = this.getRootNode();
        if (htmlElement instanceof HTMLElement) {
            var rect = htmlElement.getBoundingClientRect();
            return { x: rect.top, y: rect.left };
        }
        return null;
    };
    ValidationWrapperInternal.prototype.processBlur = function () {
        var touched = this.isChanging;
        this.isChanging = false;
        var validation = this.getOnBlurValidation(touched);
        return this.setValidation(validation);
    };
    ValidationWrapperInternal.prototype.processSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isChanging = false;
                return [2 /*return*/, this.setValidation(this.props.validation)];
            });
        });
    };
    ValidationWrapperInternal.prototype.hasError = function () {
        return getLevel(this.state.validation) === 'error';
    };
    ValidationWrapperInternal.prototype.hasWarning = function () {
        return getLevel(this.state.validation) === 'warning';
    };
    ValidationWrapperInternal.prototype.isIndependent = function () {
        return getIndependent(this.state.validation || this.props.validation) === true;
    };
    ValidationWrapperInternal.prototype.handleBlur = function () {
        var _this = this;
        setTimeout(function () {
            _this.processBlur();
            if (!_this.isIndependent()) {
                _this.context.instanceProcessBlur(_this);
            }
            _this.setState({});
        });
    };
    ValidationWrapperInternal.prototype.applyValidation = function (actual) {
        var visible = this.getVisibleValidation(actual);
        this.setValidation(visible);
    };
    ValidationWrapperInternal.prototype.setValidation = function (validation) {
        var _this = this;
        var current = this.state.validation;
        if (current === validation) {
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            _this.setState({ validation: validation }, resolve);
            if (Boolean(current) !== Boolean(validation)) {
                _this.context.onValidationUpdated(_this, !validation);
            }
        });
    };
    ValidationWrapperInternal.prototype.getOnBlurValidation = function (touched) {
        var actual = this.props.validation;
        if (getType(actual) === 'submit') {
            var visible = this.state.validation;
            return !touched && getType(visible) === 'submit' ? visible : null;
        }
        return actual;
    };
    ValidationWrapperInternal.prototype.getVisibleValidation = function (actual) {
        var visible = this.state.validation;
        if (isEqual(visible, actual)) {
            return visible;
        }
        var changing = this.context.isAnyWrapperInChangingMode();
        return getVisibleValidation(visible, actual, changing);
    };
    ValidationWrapperInternal.contextType = ValidationContext;
    return ValidationWrapperInternal;
}(React__default["default"].Component));

var ValidationWrapper = /** @class */ (function (_super) {
    __extends(ValidationWrapper, _super);
    function ValidationWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValidationWrapper.prototype.render = function () {
        var _a = this.props, children = _a.children, validationInfo = _a.validationInfo, renderMessage = _a.renderMessage, datTid = _a["data-tid"];
        var validation = validationInfo
            ? {
                level: validationInfo.level || 'error',
                behaviour: validationInfo.type || 'lostfocus',
                message: validationInfo.message,
                independent: validationInfo.independent || false,
            }
            : null;
        return (React__default["default"].createElement(ValidationWrapperInternal, { "data-tid": datTid, errorMessage: renderMessage || tooltip('right top'), validation: validation }, children));
    };
    ValidationWrapper.__KONTUR_REACT_UI__ = 'ValidationWrapper';
    ValidationWrapper.displayName = 'ValidationWrapper';
    return ValidationWrapper;
}(React__default["default"].Component));

var ValidationBuilder = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function ValidationBuilder(writer, tokens, path, data) {
        this.writer = writer;
        this.tokens = tokens;
        this.path = path;
        this.data = data;
    }
    ValidationBuilder.prototype.prop = function (lambdaPath, rule) {
        var info = this.getPathInfo(lambdaPath);
        if (isNullable(info)) {
            return;
        }
        var builder = new ValidationBuilder(this.writer, this.tokens, info.path, info.data);
        rule(builder, builder.data);
    };
    ValidationBuilder.prototype.array = function (lambdaPath, rule) {
        var info = this.getPathInfo(lambdaPath);
        if (isNullable(info) || !Array.isArray(info.data)) {
            return;
        }
        var array = info.data;
        for (var i = 0; i < array.length; ++i) {
            var path = __spreadArray(__spreadArray([], info.path, true), [i.toString()], false);
            var builder = new ValidationBuilder(this.writer, this.tokens, path, array[i]);
            rule(builder, builder.data, i, array);
        }
    };
    ValidationBuilder.prototype.invalid = function (isInvalid, messageOrValidationInfo, type, level, independent) {
        var validationWriter = this.writer.getNode(this.path);
        if (validationWriter.isValidated()) {
            return;
        }
        var invalid = isInvalid(this.data);
        if (!invalid) {
            return;
        }
        if (isValidationInfo(messageOrValidationInfo)) {
            validationWriter.set(messageOrValidationInfo);
        }
        else {
            validationWriter.set({ message: messageOrValidationInfo, type: type, level: level, independent: independent });
        }
    };
    ValidationBuilder.prototype.getPathInfo = function (lambdaPath) {
        var path = this.tokens.getOrAdd(lambdaPath);
        var data = this.data;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (isNullable(data)) {
                return null;
            }
            data = data[part];
        }
        return { data: data, path: __spreadArray(__spreadArray([], this.path, true), path, true) };
    };
    return ValidationBuilder;
}());
var isValidationInfo = function (argument) {
    return typeof argument === 'object' && Object.prototype.hasOwnProperty.call(argument, 'message');
};

var ValidationReader = /** @class */ (function () {
    function ValidationReader(node, tokens) {
        this.node = node;
        this.tokens = tokens;
    }
    ValidationReader.prototype.getNode = function (lambdaPath) {
        var path = this.tokens.getOrAdd(lambdaPath);
        return this.getReaderInternal(path);
    };
    ValidationReader.prototype.getNodeByIndex = function (index) {
        return this.getReaderInternal([index.toString()]);
    };
    ValidationReader.prototype.getNodeByKey = function (key) {
        return this.getReaderInternal([key.toString()]);
    };
    ValidationReader.prototype.get = function () {
        return this.node ? this.node.validation : null;
    };
    ValidationReader.prototype.getReaderInternal = function (path) {
        var node = this.getNodeInternal(path);
        return new ValidationReader(node, this.tokens);
    };
    ValidationReader.prototype.getNodeInternal = function (path) {
        var current = this.node;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (!current || !current.children) {
                return null;
            }
            current = current.children[part];
        }
        return current;
    };
    return ValidationReader;
}());

var ValidationWriter = /** @class */ (function () {
    function ValidationWriter(node) {
        this.node = node || { validation: null, children: null };
    }
    ValidationWriter.prototype.getReader = function (tokens) {
        return new ValidationReader(this.node, tokens);
    };
    ValidationWriter.prototype.set = function (validation) {
        this.node.validation = validation;
    };
    ValidationWriter.prototype.isValidated = function () {
        return !!this.node.validation;
    };
    ValidationWriter.prototype.getNode = function (path) {
        var node = this.getNodeInternal(path);
        return new ValidationWriter(node);
    };
    ValidationWriter.prototype.getNodeInternal = function (path) {
        var node = this.node;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var part = path_1[_i];
            if (!node.children) {
                node.children = {};
            }
            if (!node.children[part]) {
                node.children[part] = {
                    validation: null,
                    children: null,
                };
            }
            node = node.children[part];
        }
        return node;
    };
    return ValidationWriter;
}());

var classicFunctionRegEx = /^\s*function\s*\(\s*([A-Za-z0-9_$]+)\s*\)\s*\{\s*(?:(?:"use strict"|'use strict');?)?\s*return\s+\1\s*([.[].*?)?\s*;?\s*\}\s*$/;
var arrowFunctionRegEx = /^\s*\(?\s*([A-Za-z0-9_$]+)\s*\)?\s*=>\s*\1\s*([.[].*?)?\s*$/;
function extractPath(lambda) {
    var match = classicFunctionRegEx.exec(lambda) || arrowFunctionRegEx.exec(lambda);
    if (match && match.length === 3) {
        return (match[2] || '').replace(/(^\.\s*)/g, '');
    }
    throw new Error("Not supported or invalid path: <".concat(lambda, ">"));
}
function extractTokens(path) {
    return path.split(/[\s.[\]]+/g).filter(function (x) { return x; });
}
var PathTokensCache = /** @class */ (function () {
    function PathTokensCache() {
        this.cache = new Map();
    }
    PathTokensCache.prototype.getOrAdd = function (lambdaPath) {
        var lambdaString = lambdaPath.toString();
        if (!this.cache.has(lambdaString)) {
            var path = extractPath(lambdaString);
            var tokens = extractTokens(path);
            this.cache.set(lambdaString, tokens);
        }
        return this.cache.get(lambdaString);
    };
    PathTokensCache.prototype.has = function (lambdaPath) {
        var lambdaString = lambdaPath.toString();
        return this.cache.has(lambdaString);
    };
    Object.defineProperty(PathTokensCache.prototype, "size", {
        get: function () {
            return this.cache.size;
        },
        enumerable: false,
        configurable: true
    });
    return PathTokensCache;
}());

function validate(data, validationRule, tokens) {
    var validationWriter = new ValidationWriter();
    var builder = new ValidationBuilder(validationWriter, tokens, [], data);
    validationRule(builder, data);
    return validationWriter.getReader(tokens);
}
function createValidator(rule) {
    var tokens = new PathTokensCache();
    return function (value) {
        return validate(value, rule, tokens);
    };
}

exports.ValidationBuilder = ValidationBuilder;
exports.ValidationContainer = ValidationContainer;
exports.ValidationContext = ValidationContext;
exports.ValidationContextWrapper = ValidationContextWrapper;
exports.ValidationReader = ValidationReader;
exports.ValidationTooltip = ValidationTooltip;
exports.ValidationWrapper = ValidationWrapper;
exports.ValidationWrapperV1 = ValidationWrapper;
exports.ValidationsFeatureFlagsContext = ValidationsFeatureFlagsContext;
exports.createValidator = createValidator;
exports.getFullValidationsFlagsContext = getFullValidationsFlagsContext;
exports.text = text;
exports.tooltip = tooltip;
exports.validationsFeatureFlagsDefault = validationsFeatureFlagsDefault;
//# sourceMappingURL=index.js.map
